
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#2c2c30","stroke":"#707070","d":"M0 0h24v24H0z","transform":"translate(-2081 -1782)"}})])]),_c('g',{attrs:{"fill":"#2c2c30","clip-path":"url(#a)","transform":"translate(2081 1782)"}},[_c('path',{attrs:{"d":"M-2076.32-1763.965h14.717a1.606 1.606 0 001.074-.332 1.107 1.107 0 00.391-.889 2.035 2.035 0 00-.557-1.353q-.557-.64-1.172-1.245a2.115 2.115 0 01-.488-.825 6.207 6.207 0 01-.264-1.108q-.088-.6-.137-1.172a13.327 13.327 0 00-.415-3.086 6.149 6.149 0 00-1.118-2.29 4.312 4.312 0 00-1.962-1.363 3.275 3.275 0 00-.977-1.532 2.508 2.508 0 00-1.729-.625 2.526 2.526 0 00-1.733.625 3.259 3.259 0 00-.981 1.532 4.312 4.312 0 00-1.963 1.363 6.149 6.149 0 00-1.118 2.29 13.327 13.327 0 00-.415 3.086q-.059.576-.142 1.172a5.941 5.941 0 01-.259 1.108 2.115 2.115 0 01-.488.825q-.615.606-1.172 1.246a2.035 2.035 0 00-.557 1.353 1.107 1.107 0 00.391.889 1.606 1.606 0 001.074.331zm7.363 3.75a2.959 2.959 0 001.426-.342 2.841 2.841 0 001.021-.908 2.542 2.542 0 00.444-1.221h-5.791a2.542 2.542 0 00.444 1.221 2.841 2.841 0 001.021.908 2.979 2.979 0 001.435.342z"}})])])
          )
        }
      }
    